import React, { useState } from "react";

import {toast} from "react-hot-toast"

import { useNavigate } from "react-router-dom";


function FTcsPage() {




const reviewOptions = [
  "Amazing service! My pets looked so well-groomed and relaxed afterward.",
  "FluffyTouch really knows how to handle different breeds—very impressive!",
  "My companion looked happy and well-maintained. Great experience!",
  "Arrived on time and managed everything smoothly.",
  "Very professional team with excellent knowledge of popular breeds.",
  "Loved the gentle approach—they kept my pets calm throughout.",
  "FluffyTouch’s doorstep service made everything super convenient.",
  "The grooming quality was excellent, definitely satisfied.",
  "Affordable pricing and great care for all kinds of pets. Highly recommended!",
  "FluffyTouch delivered a seamless and comfortable grooming session."
];




  const [selectedReview, setSelectedReview] = useState("");


  const [loading , setLoading] = useState(false);

  const navigate = useNavigate();

  const [data, setData] = useState({
    customerName: "",
    customerNumber: "",
    servicesName: "",
    serviceDate: "",
    ratingNumber: 0,
    ratingMessage: "",
    userType:"user"
  });

  const seckey = process.env.REACT_APP_REV_KEY;
  const apiUrl = process.env.REACT_APP_API_URL;

  const [hoverStar, setHoverStar] = useState(0);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };


    const handleSelectReview = (review) => {
    setData({
      ...data,
      ratingMessage: review
    });
  };




  const submitForm = async (e) => {
    e.preventDefault();

if (data.customerNumber && data.customerNumber.length != 10) {
  alert("Invalid Number");
  return;
}else if(data.ratingNumber === 0){
  alert("Please select rating");
  return
} else{

setLoading(true)

    try {
      const response = await fetch(`${apiUrl}/auth/post-ft-reviews`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "seckey":seckey
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();
  
    if(response.ok){

        // toast.success(result.message)
      navigate("/thanks-feedback")

          setData({
      customerName: "",
      customerNumber: "",
      servicesName: "",
      serviceDate: "",
      ratingNumber: 0,
      ratingMessage: "",
      BreedName:"",
      userType: "user"
    });


      }else{
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false)
  }

  };

  return (
    <div>
      <div className="glazma-cs-page-bg">
        <div className="glazma-cs-page-main">
          <div className="glazma-cs-page-content">
            <form onSubmit={submitForm}>
              <div className="glazma-cs-page-main-content">
                <h2>Leave a review</h2>

                <div className="custome-rev-fill-input-row">
                  <div className="custome-rev-fill-input-col">
                    <input
                      name="customerName"
                      value={data.customerName}
                      onChange={handleChange}
                      placeholder="Enter your Name"
                      required
                    />
                  </div>

                  <div className="custome-rev-fill-input-col">
                    <input
                      name="customerNumber"
                      value={data.customerNumber}
                      onChange={handleChange}
                      placeholder="Enter your Number (Optional)"
                    />
                  </div>
                </div>

              

                {/* ROW 2 */}
                <div className="custome-rev-fill-input-row">
                  <div className="custome-rev-fill-input-col">
                    <input
                      name="servicesName"
                      value={data.servicesName}
                      onChange={handleChange}
                      placeholder="Enter Service Name"
                      required
                    />
                  </div>

                  <div className="custome-rev-fill-input-col">
                    <input
                      type="date"
                      name="serviceDate"
                      value={data.serviceDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                  <div>
                   <div className="custome-rev-fill-input-col">
                    <input
                      name="BreedName"
                      value={data.BreedName}
                      onChange={handleChange}
                      placeholder="Enter your BreedName"
                    />
                  </div>
                </div>


                        <div className="review-msg-box">
           <label>Select Review</label>
      {reviewOptions.map((review, index) => (
        <div className="msg-option" key={index}>
          <input
            type="radio"
            id={`r${index + 1}`}
            name="review"
            value={review}
            checked={data.ratingMessage === review}
            onChange={() => handleSelectReview(review)}
          />
          <label htmlFor={`r${index + 1}`} className="msg-bubble">
            {review}
          </label>
        </div>
      ))}

            </div>



  {/* STAR RATING */}
                <div className="custome-rev-fill-input-row">
                  <h4>Click the stars to rate us*</h4>
                </div>

                 <div className="custome-rev-fill-input-row-start">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={
                        star <= (hoverStar || data.ratingNumber)
                          ? "fa-solid fa-star"
                          : "fa-regular fa-star"
                      }
                      style={{ cursor: "pointer", color: "#FFD700", fontSize: 25 }}
                      onMouseEnter={() => setHoverStar(star)}
                      onMouseLeave={() => setHoverStar(0)}
                      onClick={() => setData({ ...data, ratingNumber: star })}
                    ></i>
                  ))}
                </div>


                {/* MESSAGE */}
                <div className="custome-rev-fill-message-row">
                  <label>Review*</label>
                  <textarea
                    name="ratingMessage"
                    value={data.ratingMessage}
                    onChange={handleChange}
                    rows={7}
                    required
                  ></textarea>
                </div>

                {/* SUBMIT BUTTON */}
                <div className="custome-rev-fill-message-row">
                  <button type="submit">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FTcsPage;

// export default GOCcspage 
// export default FTcsPage